// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-btn[data-v-6a263f3e] {\r\n  padding: 0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
